// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq-box[data-v-e9dcf34c],.mybookings-box[data-v-e9dcf34c]{border-bottom:1px solid #eaeaea;box-shadow:none}.mybookings-box[data-v-e9dcf34c]{margin-bottom:30px}.contact-view label[data-v-e9dcf34c]{width:90%}.contact-view label.active[data-v-e9dcf34c]{width:100%}.row .first-uppercase[data-v-e9dcf34c]{display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
